<!--TODO - Below commented code will be removed by ORG-5881-->
<!--<div *transloco="let t">
	<div id="sh-switch-org-main-div">
		<prism-org-switcher>
			<div class="sh-switch-org-container" [ngClass]="contentOrientation()">
				<prism-profile-image
					[attr.first-name]="initials()[0]"
					[attr.last-name]="initials()[1]"
					slot="profile"
				></prism-profile-image>
				<span id="sh-switch-org-default-org-name-div">
					{{ organizationName() }}
				</span>

				<prism-button
					id="sh-switch-org-change-button"
					(click)="openChangeOrganization()"
					variant="text"
					slot="button"
					>{{ t('cloud.shared.switch-org.change') }}</prism-button
				>
			</div>
		</prism-org-switcher>
		<div id="sh-switch-org-line-div"></div>
	</div>
</div>-->

<!--<div id="sh-switch-org-main-div" *transloco="let t">
	<prism-org-switcher>
		<div class="sh-switch-org-container" [ngClass]="contentOrientation()">
			<prism-profile-image
				[attr.first-name]="initials()[0]"
				[attr.last-name]="initials()[1]"
				slot="profile"
			></prism-profile-image>
			<p id="sh-switch-org-default-org-name-div">
				<prism-tooltip text="cwcce" disabled="false" placement="top">
					<span>{{ organizationName() }}</span>
				</prism-tooltip>
			</p>

			<prism-button
				id="sh-switch-org-change-button"
				(click)="openChangeOrganization()"
				variant="text"
				slot="button"
				>{{ t('cloud.shared.switch-org.change') }}</prism-button
			>
		</div>
	</prism-org-switcher>
</div>-->

<div *transloco="let t">
	<div class="sh-switch-org-container" [ngClass]="contentOrientation()">
		<div id="sh-switch-org-default-org-char-div">
			<prism-profile-image
				id="sh-switch-org-profile-image"
				size="small"
				[firstName]="initials().firstInitial"
				[lastName]="initials().secondInitial"
			></prism-profile-image>
		</div>
		<div id="sh-switch-org-default-org-name-div">
			{{ organizationName() }}
		</div>
		<prism-button
			id="sh-switch-org-change-button"
			[variant]="contentOrientation() === 'columnLayout' ? 'text' : 'standard'"
			(click)="openChangeOrganization()"
		>
			{{ t('cloud.shared.switch-org.change') }}
		</prism-button>
	</div>
	<div id="sh-switch-org-line-div"></div>
</div>
